import { Link } from 'react-router-dom';
import formPics from '../assets/images/formwork2.jpg';
import roof from '../assets/images/roof.jpg';
import concretePics from '../assets/images/concrete.jpg';
import blockPics from '../assets/images/blockwork.jpg';
import steelPics from '../assets/images/steel2.jpg';
import mortalpics from '../assets/images/mortar.jpg';

const navbar = () => {
    return ( 
        
        <div className="wrapper">
        
          {/* Major side */}
           
          <div className="sidebar">
  <table className="sidebar-table">
    <tbody>
      <tr>
        <td className="sidebar-cell">
          <Link to="/sections/Concrete" >
          <img src={concretePics} className="" alt="pics" width="150" height="100" />
          <h3>Concrete Estimation </h3>

          </Link>
        </td>
        <td className="sidebar-cell"> 
          <Link to="/sections/blockwork">
          <img src={blockPics} className="pics" alt="pics" width="150" height="100" />
            <h3>Blockwork Estimation</h3></Link>
        </td>

        <td className="sidebar-cell">
        <Link to="/sections/Concrete">
          <img src={mortalpics} className="pics" alt="pics" width="150" height="100" />
            <h3>Mortar Estimation </h3> 
          </Link>
        </td>
      </tr>
      <tr>
        <td className="sidebar-cell">
        <Link to="/sections/Steelwork">
          <img src={steelPics} className="pics" alt="pics" width="150" height="100" />
           <h3>  Steel Estimation</h3>
          </Link>
        </td>
        <td className="sidebar-cell">
      <Link to="/sections/Formwork">
          <img src={formPics} className="pics" alt="pics" width="150" height="100" />
           <h3>Formwork Estimation </h3>
          </Link>
               
        </td>
        
        <td className="sidebar-cell">
       <Link to="/pages/ComingSoon"> 
          <img src={roof} className="pics" alt="pics" width="150" height="100" />
           <h3>Roof Estimation</h3> 
          </Link>
           </td>
      </tr>
    </tbody>
  </table>
</div>

        </div>
        
                
     );
}
 
export default navbar;